import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Button } from './ui/Button';
export function StickyCtaBar() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollY
  } = useScroll();
  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsVisible(latest > 600);
    });
  }, [scrollY]);
  if (!isVisible) return null;
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: 0
  }} exit={{
    y: 100
  }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-neutral-950/80 backdrop-blur-md border-t border-neutral-800 md:hidden" data-id="element-169">
      <div className="flex items-center justify-between gap-4" data-id="element-170">
        <div className="flex flex-col" data-id="element-171">
          <span className="text-xs text-neutral-400" data-id="element-172">
            Plan de Supervivencia
          </span>
          <span className="text-white font-bold" data-id="element-173">$6.33 USD</span>
        </div>
        <Button size="md" onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-174">
          Descargar
        </Button>
      </div>
    </motion.div>;
}